import { trans } from "../utils"


const UploadExcelButton = ({data,GetModuleData}) => {


    return (


        <>
            {data.getmodule == "Ticket" || data.getmodule  == "Extract" || data.getmodule  == "WorkOrder"? "" :
                <button type="button"
                        className="btn btn-light-primary font-weight-bolder btn-sm p-4"
                        data-toggle="modal"
                        data-target="#AssignModal">
                    {trans('Upload')} {trans(GetModuleData.name_en)}
                </button>
            }

        </>
    )

}

export default UploadExcelButton